import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "20.008",
  cy: "19.998",
  r: "17.778",
  fill: "#D9D9D9"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21.267 2.934c-.42-.03-.84-.046-1.26-.046V.443c.481 0 .961.019 1.44.054l-.18 2.437Zm4.898 1.1a17.116 17.116 0 0 0-2.408-.73l.536-2.386c.936.21 1.858.488 2.752.836l-.88 2.28Zm3.349 1.736c-.35-.233-.707-.453-1.073-.66l1.205-2.127a19.615 19.615 0 0 1 2.393 1.599L30.536 6.51a17.081 17.081 0 0 0-1.022-.738V5.77Zm4.483 4.375A17.08 17.08 0 0 0 32.401 8.2l1.77-1.687c.66.697 1.27 1.442 1.826 2.224l-2 1.408Zm1.819 3.305c-.16-.387-.335-.769-.523-1.144l2.183-1.1c.431.859.799 1.747 1.1 2.66l-2.323.765a17.155 17.155 0 0 0-.437-1.18Zm1.295 6.128c-.02-.84-.101-1.677-.244-2.505l2.408-.416c.163.944.259 1.902.283 2.86l-2.444.061h-.003Zm-.32 3.76c.08-.416.147-.829.198-1.247l2.428.301a19.464 19.464 0 0 1-.563 2.823l-2.356-.652c.112-.404.21-.812.293-1.225Zm-2.327 5.815a17.26 17.26 0 0 0 1.188-2.22l2.234.99c-.39.88-.843 1.727-1.356 2.538l-2.066-1.308ZM32.108 32.1c.298-.298.584-.606.855-.924l1.853 1.596c-.314.364-.64.716-.98 1.056L32.108 32.1Z",
  fill: "#333"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M20.008 2.888a17.111 17.111 0 1 0 12.1 29.21l1.728 1.73A19.558 19.558 0 1 1 20.008.442v2.445Z",
  fill: "#333"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18.785 7.777A1.222 1.222 0 0 1 20.007 9v12.735l7.94 4.537a1.222 1.222 0 0 1-1.212 2.122l-8.556-4.89a1.223 1.223 0 0 1-.616-1.06V9a1.222 1.222 0 0 1 1.222-1.223Z",
  fill: "#333"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render: render }